import {
  Avatar,
  Breadcrumbs,
  Button,
  Card,
  CardActionArea,
  CardActions,
  CardContent,
  Chip,
  CircularProgress,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Divider,
  Fade,
  Grid,
  IconButton,
  List,
  ListItem,
  ListItemAvatar,
  ListItemIcon,
  ListItemText,
  makeStyles,
  Slide,
  Snackbar,
  Typography,
} from "@material-ui/core";
import Skeleton from "@material-ui/lab/Skeleton";
import { blueGrey, green, purple, red } from "@material-ui/core/colors";
import { Clear, Done, DoneAll, Email, Event, Face, Home, Image, LocationOnOutlined, Phone, RemoveRedEyeOutlined, ScheduleOutlined } from "@material-ui/icons";
import { Alert } from "@material-ui/lab";
import moment from "moment";
import React, { useEffect, useState } from "react";
import { AuthUserContext, withAuthorization } from "../Session";
import Lottie from "lottie-react";
import { useTranslation } from "react-i18next";
import CarrouselChips from "./Chips";
import FirstFormationCard from "./FirstFormationCard";
import Footer from "../Footer";
import { Link, useHistory } from "react-router-dom";
import * as ROUTES from "../../constants/routes";

const OnsiteTrainingPage = (props) => {
  const { firebase } = props;
  const { t } = useTranslation();
  const classes = useStyles();
  const history = useHistory();

  const [firstWorkshopData, setFirstWorkshopData] = useState({});
  const [selectedWorkshop, setSelectedWorkshop] = useState(0);
  const [hasFristWorkshop, sethasFristWorkshop] = useState(false);

  useEffect(() => {
    firebase
      .user(firebase.currentUser().uid)
      .once("value")
      .then((snap) => {
        if (snap.val().sgpfc?.userCreatedByForm !== undefined) {
          const WorkshopData = snap.val().sgpfc?.userCreatedByForm;
          firebase
            .rescuersFormsRef(WorkshopData.formId)
            .once("value")
            .then((snap) => {
              if (moment(snap.val().formationGroups[WorkshopData.workshop].time).isAfter()) {
                setFirstWorkshopData(snap.val());
                setSelectedWorkshop(WorkshopData.workshop);
                sethasFristWorkshop(true);
              }
            });
        }
      });
  }, []);

  return (
    <>
      <Grid container justify="center">
        <Grid container item xs={12} lg={8} className={classes.headerContainer}>
          <Breadcrumbs className={classes.breadcrumbs}>
            <Link
              color="inherit"
              style={{ cursor: "pointer" }}
              onClick={() => {
                history.push(ROUTES.HOME);
                window.scrollTo(0, 0);
              }}
            >
              <div style={{ display: "flex" }}>
                <Home style={{ paddingBottom: 8, paddingRight: 4 }} />
                <Typography style={{ paddingTop: 4, textDecoration: "underline" }}>{t("curso_Online")}</Typography>
              </div>
            </Link>
          </Breadcrumbs>
        </Grid>
        <Grid item xs={12} xl={7} lg={8} container spacing={6}>
          <Grid item xs={12}>
            <Typography variant="h4" color="primary" style={{ fontWeight: 500, marginTop: 36, marginBottom: 16 }}>
              {t("nextOnsiteCourses")}
            </Typography>
            <Typography variant="body1" color="textSecondary" style={{ fontWeight: 400 }}>
              {t("nextOnsiteCoursesSubtitle")}
            </Typography>
          </Grid>
          <Grid item container spacing={1} justify="center">
            <FirstFormationCard workshopData={firstWorkshopData} workshop={selectedWorkshop} />
            <AuthUserContext.Consumer>
              {(authUser) => {
                let toRender = [];
                if (!!authUser?.sgpfc?.onSiteTrainings?.forms) {
                  toRender = Object.keys(authUser.sgpfc.onSiteTrainings.forms)
                    .filter((t) => moment(authUser.sgpfc.onSiteTrainings.forms[t].endDay, "DD/MM/YYYY").add(2, "d").isAfter(moment()))
                    .reverse();
                }
                return toRender.length > 0
                  ? toRender.map((key, i) => (
                      <OnsiteTrainingCard
                        firebase={firebase}
                        key={i}
                        id={key}
                        data={authUser.sgpfc.onSiteTrainings.forms[key]}
                        nextSchedule={authUser?.sgpfc?.onSiteTrainings?.next}
                      />
                    ))
                  : !hasFristWorkshop && (
                      <Grid container item xs={12} alignItems="center" justify="center" direction="column">
                        <Grid item container justify="center">
                          <Lottie animationData={require("../../assets/empty-box.json")} autoPlay style={{ width: "25vh", height: "25vh", marginBottom: 19 }} />
                        </Grid>
                        <Typography variant="h5">{t("coursesNotAvailable")}</Typography>
                      </Grid>
                    );
              }}
            </AuthUserContext.Consumer>
          </Grid>
        </Grid>
      </Grid>

      <div className={classes.footerContainer}>
        <Footer />
      </div>
    </>
  );
};

const condition = (authUser) => !!authUser;

export default withAuthorization(condition)(OnsiteTrainingPage);

const OnsiteTrainingCard = ({ id, data, firebase, nextSchedule }) => {
  const classes = useStyles();
  const { t } = useTranslation();

  const [isScheduleSelected, setIsScheduleSelected] = useState(false);
  const [selectedSchedule, setSelectedSchedule] = useState(-1);
  const [savedSchedule, setSavedSchedule] = useState(-1);
  const [openSnackOnSuccess, setOpenSnackOnSuccess] = useState(false);
  const [openSnackOnRemoved, setOpenSnackOnRemoved] = useState(false);
  const [isLoaded, setIsLoaded] = useState(false);
  const [groupData, setGroupData] = useState();
  const [isFormOpen, setIsFormOpen] = useState(false);
  const [savingSchedule, setSavingSchedule] = useState(false);
  const [openModal, setOpenModal] = useState(false);
  const [cancelModal, setCancelModal] = useState(true);
  const [name, setName] = useState({});
  const [errorOnLoad, setErrorOnLoad] = useState(false);

  useEffect(() => {
    const refreshmentFormsRef = firebase.refreshmentFormsRef(id);
    refreshmentFormsRef.parent
      .child("name")
      .once("value")
      .then((snap) => {
        setName(snap.val());
      });

    refreshmentFormsRef.on("value", (snap) => {
      if (snap.val() == undefined) {
        setErrorOnLoad(true);
      } else {
        setGroupData({ ...data, refreshmentGroups: snap.val() });
        setIsLoaded(true);
        setIsFormOpen(moment().isBetween(moment(snap.val().startDay, "DD/MM/YYYY"), moment(snap.val().endDay, "DD/MM/YYYY"), "day", "[]"));
      }
    });

    return () => {
      refreshmentFormsRef.off("value");
    };
  }, []);

  useEffect(() => {
    setSelectedSchedule(!!data?.selectedSchedule ? data.selectedSchedule.id : -1);
    setSavedSchedule(!!data?.selectedSchedule ? data.selectedSchedule.id : -1);
  }, [data]);

  const onChipselected = (id) => {
    if (isFormOpen) {
      setSelectedSchedule(id);
      setIsScheduleSelected(true);
    }
  };

  const cancelSchedule = () => {
    if (isFormOpen) {
      setIsScheduleSelected(false);
      setSelectedSchedule(-1);
      setSavedSchedule(-1);
      setOpenSnackOnRemoved(true);
      firebase.userOnsiteTrainingRef(id).child("selectedSchedule").remove();
      firebase
        .userOnsiteTrainingRef(id)
        .parent.parent.update({
          next: null,
        })
        .then(() => setCancelModal(false));
    }
  };

  const saveSchedule = () => {
    if (isFormOpen) {
      setIsScheduleSelected(false);
      setSavingSchedule(true);
      setSavedSchedule(selectedSchedule);

      firebase
        .userOnsiteTrainingRef(id)
        .update({
          selectedSchedule: {
            text: moment(groupData?.refreshmentGroups?.groups[selectedSchedule].time).format("dddd DD MMM · HH:mm"),
            id: selectedSchedule,
            email: firebase.currentUser().email,
            name: firebase.currentUser().displayName,
          },
          isReviewed: true,
        })
        .then(() => {
          if (!nextSchedule || !moment(nextSchedule.time).isValid()) {
            firebase
              .userOnsiteTrainingRef(id)
              .parent.parent.update({
                next: { time: groupData?.refreshmentGroups?.groups[selectedSchedule].time, id: id },
              })
              .then(() => setSavingSchedule(false));
          } else if (moment(nextSchedule.time).isValid && nextSchedule.id != id) {
            moment(nextSchedule).isAfter(groupData?.refreshmentGroups?.groups[selectedSchedule].time)
              ? firebase
                  .userOnsiteTrainingRef(id)
                  .parent.parent.update({
                    next: { time: groupData?.refreshmentGroups?.groups[selectedSchedule].time, id: id },
                  })
                  .then(() => setSavingSchedule(false))
              : setSavingSchedule(false);
          } else if (nextSchedule.id == id) {
            firebase
              .userOnsiteTrainingRef(id)
              .parent.parent.update({
                next: { time: groupData?.refreshmentGroups?.groups[selectedSchedule].time, id: id },
              })
              .then(() => setSavingSchedule(false));
          }
          setOpenSnackOnSuccess(true);
        });
    }
  };

  const changeGroup = () => {
    if (savedSchedule != -1 && selectedSchedule != savedSchedule) {
      setOpenModal(true);
    } else {
      saveSchedule();
    }
  };

  useEffect(() => {
    setOpenModal(false);
    setCancelModal(false);
  }, [savingSchedule]);

  if (!errorOnLoad) {
    return (
      <Grid item xs={12} lg={6} elevation={1}>
        <Card style={{ borderRadius: 12, backgroundColor: purple[50] }} elevation={3}>
          <CardContent>
            <Typography variant="h5">{isLoaded ? name : <Skeleton />}</Typography>
            <Typography variant="body1" component="h2" gutterBottom style={{ fontWeight: 500, color: isFormOpen ? green[500] : red[500], marginBottom: 12 }}>
              {isLoaded ? (
                isFormOpen ? (
                  t("inscriptionIsOpenUntil", { time: moment(groupData?.refreshmentGroups?.endDay, "DD/MM/YYYY").format("DD/MM") })
                ) : moment(groupData?.refreshmentGroups?.startDay, "DD/MM/YYYY").isAfter(moment()) ? (
                  t("inscriptionOpenOn", { time: moment(groupData?.refreshmentGroups?.startDay, "DD/MM/YYYY").format("DD/MM") })
                ) : (
                  t("closedRegistration")
                )
              ) : (
                <Skeleton />
              )}
            </Typography>
            <Grid container alignItems="center">
              <LocationOnOutlined fontSize="small" style={{ marginRight: 6 }} />
              <Typography variant="body1" color="textSecondary" component="p">
                {isLoaded ? t("place", { place: groupData?.refreshmentGroups?.place }) : <Skeleton width={128} />}
              </Typography>
            </Grid>
            <Grid container alignItems="center">
              <ScheduleOutlined fontSize="small" style={{ marginRight: 6 }} />
              <Typography variant="body1" color="textSecondary" component="p">
                {isLoaded ? t("duration", { duration: groupData?.refreshmentGroups?.duration }) : <Skeleton variant="text" width={128} />}
              </Typography>
            </Grid>
          </CardContent>
          <Divider style={{ marginRight: 16, marginLeft: 16 }} />
          <CardContent>
            <Typography variant="body1" component="h2" color="primary" style={{ fontWeight: 500, marginBottom: 9 }}>
              {t("availableSchedule")}
            </Typography>
            <div className={classes.chipsRoot}>
              {isLoaded ? (
                <CarrouselChips selectedSchedule={selectedSchedule} groups={groupData?.refreshmentGroups?.groups} onChipselected={onChipselected} savedSchedule={savedSchedule} />
              ) : (
                [0, 1, 2, 3].map(() => <Skeleton variant="rect" width={164} height={32} style={{ borderRadius: 32 }} />)
              )}
            </div>
          </CardContent>
          <CardActions>
            <Grid container justify="flex-end">
              <Fade in={savedSchedule !== -1}>
                <Button
                  size="small"
                  disabled={!isFormOpen || savingSchedule}
                  onClick={() => {
                    setCancelModal(true);
                  }}
                  style={{ borderRadius: 6, textTransform: "none", marginRight: 9, color: (isFormOpen || savingSchedule) && red[500] }}
                >
                  {t("cancelRegistration")}
                </Button>
              </Fade>
              <Button
                size="small"
                onClick={changeGroup}
                disabled={!isScheduleSelected || !isFormOpen || selectedSchedule == savedSchedule}
                color="primary"
                variant="contained"
                style={{ borderRadius: 6, textTransform: "none" }}
              >
                {t("saveRegistration")}
                {savingSchedule && (
                  <CircularProgress
                    size={24}
                    style={{
                      position: "absolute",
                      top: "50%",
                      left: "50%",
                      marginTop: -12,
                      marginLeft: -12,
                    }}
                  />
                )}
              </Button>
            </Grid>
          </CardActions>
        </Card>

        <Dialog aria-labelledby="simple-dialog-title" open={openModal}>
          <DialogTitle id="simple-dialog-title">{t("confirmInscription")}</DialogTitle>
          <DialogContent>{t("DoYouWhantToChangeSchedule")}</DialogContent>
          <DialogActions>
            <Button
              onClick={() => {
                setOpenModal(false);
                setSelectedSchedule(savedSchedule);
              }}
            >
              {t("no")}
            </Button>
            <Button onClick={saveSchedule}>{t("yes")}</Button>
          </DialogActions>
        </Dialog>
        <Dialog aria-labelledby="simple-dialog-title" open={cancelModal}>
          <DialogTitle id="simple-dialog-title">{t("doYouWantToUnsubscribe")}</DialogTitle>
          <DialogContent>{t("")}</DialogContent>
          <DialogActions>
            <Button onClick={() => setCancelModal(false)}>{t("no")}</Button>
            <Button onClick={cancelSchedule}>{t("yes")}</Button>
          </DialogActions>
        </Dialog>
        <Snackbar
          open={openSnackOnSuccess}
          anchorOrigin={{ vertical: "bottom", horizontal: "right" }}
          autoHideDuration={6000}
          onClose={() => {
            setOpenSnackOnSuccess(false);
          }}
        >
          <Alert severity="success">{t("inscriptionSuccessSnack")}</Alert>
        </Snackbar>
        <Snackbar
          open={openSnackOnRemoved}
          anchorOrigin={{ vertical: "bottom", horizontal: "right" }}
          autoHideDuration={6000}
          onClose={() => {
            setOpenSnackOnRemoved(false);
          }}
        >
          <Alert severity="warning">{t("inscriptionCancelSnack")}</Alert>
        </Snackbar>
      </Grid>
    );
  } else {
    return <></>;
  }
};

const useStyles = makeStyles((theme) => ({
  chipsRoot: {
    display: "flex",
    justifyContent: "start",
    flexWrap: "wrap",
    "& > *": {
      margin: theme.spacing(0.5),
    },
  },

  footerContainer: {
    paddingTop: 64,
  },
  headerContainer: {
    [theme.breakpoints.up("md")]: {
      marginTop: 12,
      // paddingTop: 32,
    },
    [theme.breakpoints.down("md")]: {
      marginTop: 12,
      paddingTop: 20,
    },
  },
  breadcrumbs: {
    [theme.breakpoints.up("md")]: {
      // marginTop: -42,
      //  marginBottom: 0,
    },
    [theme.breakpoints.down("md")]: {
      //marginTop: -20,
      marginBottom: 8,
    },
  },
}));
